export const USER_ROUTES = {
  AUTHENTICATION: {
    LOGIN: {
      NAME: "auth-login",
      PATH: "/user/login"
    },
    PASSWORD_CHANGE: {
      REQUEST: {
        NAME: "auth-pwd-chg-request",
        PATH: "/user/password-change/request"
      },
      FROM_INVITATION: {
        NAME: "auth-pwd-chg-from-invitation",
        PATH: "/user/password-change/from-invitation"
      },
      FROM_REQUEST: {
        NAME: "auth-pwd-chg-from-request",
        PATH: "/user/password-change/from-request"
      }
    },
    SSO: {
      NAME: "auth-sso",
      PATH: "/user/sso"
    }
  },
  SETTINGS: {
    NAME: "user-settings",
    PATH: "/user/settings"
  },
  TERMS_OF_SERVICES: {
    NAME: "user-terms-of-services",
    PATH: "/terms-of-services"
  },
  PRIVACY_POLICY: {
    NAME: "user-privacy-policy",
    PATH: "/privacy-policy"
  }
};
